import type { Message } from '@/features/messages/models/message';
import { ContentCopy } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

interface MesageMenuCopyItemProps {
  message: Message;
  onClose: () => void;
}

export const MesageMenuCopyItem: FC<MesageMenuCopyItemProps> = ({ message, onClose }) => {
  const { t } = useTranslation();

  const handleCopy = async () => {
    if (!message.content) return;

    try {
      await navigator.clipboard.writeText(message.content);
      toast.success(t('messages.toasts.copySuccess'));
    } catch (error) {
      toast.error(t('messages.toasts.copyError'));
    }
    onClose();
  };

  return (
    <MenuItem onClick={handleCopy}>
      <ListItemIcon>
        <ContentCopy />
      </ListItemIcon>
      <ListItemText>{t('messages.actions.copy')}</ListItemText>
    </MenuItem>
  );
};
